import { render } from "./foreignerLicense.vue?vue&type=template&id=75e163fc"
import script from "./foreignerLicense.vue?vue&type=script&lang=js"
export * from "./foreignerLicense.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__